export default {
    contractTotals: {
        heading: 'Contract onsite total',
        syncStatus: 'Service sync: {status}. Last attempt: {attempt}. Last success: {success}. Next retry: {retry}.',
        syncNever: 'Not attempted',
        syncPending: 'Queued',
        syncRunning: 'Syncing with Service',
        syncSuccess: 'Current',
        syncFailed: 'Needs attention',
        syncFailure: 'Service contract sync needs attention. Open contract and sync details for more information.',
        syncNoDate: 'None',
        syncWarning: '{pending} bookings await reconciliation; {review} bookings need staff review.',
        syncReason: 'Sync issue: {reason}.',
        description: 'Service supplies the contract total. A MarketScale override changes the full-contract booking cap; the Enterprise per-quarter setting above stays separate.',
        loading: 'Loading contract totals…',
        unavailable: 'Contract totals are unavailable. Try reloading this section.',
        empty: 'No current or future active Service contracts are available for this channel.',
        contract: 'Service contract {id}',
        dates: '{start} to {end}',
        totals: 'Service base: {source} · Effective base: {effective} · Production allotments committed: {used}',
        reviewRequired: 'Service changed this contract total. Review whether local additions are already included before accepting it. The previous base remains in use until reconciled.',
        localTotals: 'Local additions and transfers: {additions} · Full-contract allotments: {total}',
        previewTotal: 'After saving: {total} full-contract allotments, including local additions. If Service already includes those additions, subtract them from the base entered here to avoid counting them twice.',
        override: 'Admin override: {total}',
        reached: 'This contract has reached its current total. Existing bookings remain recorded; new bookings require available capacity.',
        change: 'Change total',
        totalLabel: 'Contract base before local additions',
        reasonLabel: 'Reason for change',
        save: 'Save override',
        reset: 'Use Service total',
        recent: 'Recent changes',
        audit: '{actor} · {date} · Contract {contract}: {old} → {current}. {reason}',
        unknown: 'Unknown',
        formerUser: 'Former user',
        saveError: 'The total could not be saved. Check the quantity and reason, then try again.',
        inputError: 'Enter a whole number from 0 to 100000 and a reason of at least three characters.',
        reasonError: 'Enter a reason of at least three characters.',
    },
    // C
    createOrganization: 'Create Channel',

    // D
    downloadContent: 'to download this content',

    // I
    interactContent: 'to interact with content',

    // L
    likeContent: 'to like this content',

    // P
    participateConversation: 'to participate in the conversation',
}
